/* eslint-disable no-undef */

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  // define calm start buttons
  const startDailySessionButton = document.querySelector('[data-name="start_daily_session"]');
  const sessionErrorText = document.querySelector('[data-name="session-error-text"]');
  const study = await Wized.requests.waitFor('get_study');
  const user = await Wized.requests.waitFor('get_user');
  if (!user.data.study_group.session_enabled) {
    startDailySessionButton.classList.add('hide');
    sessionErrorText.classList.remove('hide');
  }

  var redirect_url = study.data.study.session_page;

  const sessionStartTime = sessionStorage.getItem('sessionStartTime');
  const now = new Date();
  const diffInMs = now - sessionStartTime;
  const diffInMinutes = diffInMs / (1000 * 60);
  const hasNotExpired = diffInMinutes < 30;

  const sessionID = sessionStorage.getItem('sessionId');
  const finishedPresession = sessionStorage.getItem('finishedPreSession');

  if (finishedPresession && !hasNotExpired) {
    startDailySessionButton.textContent = 'Continue';
  }
  startDailySessionButton.addEventListener('click', async (event) => {
    event.preventDefault();
    if (finishedPresession && !hasNotExpired) {
      window.location.href = `${redirect_url}?session_id=${sessionID}`;
      startDailySessionButton.textContent = 'Continue';
    } else {
      var default_text = event.target.textContent;
      Wized.data.v.session_metadata = { sessionType: 'Daily Practice' };
      try {
        const session = await Wized.requests.execute('create_session');
        startDailySessionButton.textContent = 'Loading Session';
        startDailySessionButton.style.pointerEvents = 'none';
        window.location.href = `${redirect_url}?session_id=${session.data.id}`;
      } catch (error) {
        console.error('Error:', error);
        startDailySessionButton.textContent = default_text;
        startDailySessionButton.style.pointerEvents = 'auto';
      }
    }
  });
});
